import SolicitarInfoForm from './SolicitarInfoForm';

export default SolicitarInfoForm;
